import { render, staticRenderFns } from "./AgencyAvatar.vue?vue&type=template&id=c8f7ff94"
import script from "./AgencyAvatar.vue?vue&type=script&lang=ts"
export * from "./AgencyAvatar.vue?vue&type=script&lang=ts"
import style0 from "./AgencyAvatar.vue?vue&type=style&index=0&id=c8f7ff94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports